module.exports = __webpack_public_path__ + "img/error-403.b6ebe1ae.svg";